/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Scene_Change_Detection_Marker_CommentInputs */

const en_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shot Change ${i?.number}`)
};

const fr_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Changement de plan ${i?.number}`)
};

const de_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Schusswechsel ${i?.number}`)
};

const it_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cambio di tiro ${i?.number}`)
};

const ru_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Смена кадра ${i?.number}`)
};

const es_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cambio de tiro ${i?.number}`)
};

const zh_cn2_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`投篮变化${i?.number}`)
};

const ja_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ショットチェンジ ${i?.number}`)
};

const hi_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन ${i?.number}`)
};

const pt_pt2_scene_change_detection_marker_comment = /** @type {(inputs: Scene_Change_Detection_Marker_CommentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Troca de dose ${i?.number}`)
};

/**
* | output |
* | --- |
* | "Shot Change {number}" |
*
* @param {Scene_Change_Detection_Marker_CommentInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_marker_comment = /** @type {((inputs: Scene_Change_Detection_Marker_CommentInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Marker_CommentInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_scene_change_detection_marker_comment(inputs)
	if (locale === "de") return de_scene_change_detection_marker_comment(inputs)
	if (locale === "it") return it_scene_change_detection_marker_comment(inputs)
	if (locale === "ru") return ru_scene_change_detection_marker_comment(inputs)
	if (locale === "es") return es_scene_change_detection_marker_comment(inputs)
	if (locale === "zh-CN") return zh_cn2_scene_change_detection_marker_comment(inputs)
	if (locale === "ja") return ja_scene_change_detection_marker_comment(inputs)
	if (locale === "hi") return hi_scene_change_detection_marker_comment(inputs)
	if (locale === "pt-PT") return pt_pt2_scene_change_detection_marker_comment(inputs)
	return en_scene_change_detection_marker_comment(inputs)
});